export enum RemoveItemsFromMappingWarningDialogActions {
    REMOVE = 'REMOVE',
    CANCEL = 'CANCEL',
}
